<script lang="ts">
	import SeoHead from './SeoHead.svelte';
	import JsonLd from './JsonLd.svelte';
	import type { buildSeoMeta } from '$lib/seo';

	type SeoData = ReturnType<typeof buildSeoMeta>;

	let { data }: { data: { seo?: SeoData; jsonld?: string } } = $props();
</script>

{#if data.seo}
	<SeoHead seo={data.seo} />
{/if}
{#if data.jsonld}
	<JsonLd schemas={data.jsonld} />
{/if}
